import { gql } from '@apollo/client';

// Queries
export const GET_WHERE_TO_GO_ITEMS = gql`
  query GetWhereToGoItems($categoryId: String) {
    whereToGoItems(categoryId: $categoryId) {
      id
      title
      description
      imageUrl
      address
      city
      state
      zipCode
      phoneNumber
      website
      tips
      promotionBannerText
      promotionDetails
      promotionColor
      isActive
      areas
      categories {
        id
        name
      }
    }
  }
`;

export const GET_WHERE_TO_GO_ITEM = gql`
  query GetWhereToGoItem($id: ID!) {
    whereToGoItem(id: $id) {
      id
      title
      description
      imageUrl
      address
      city
      state
      zipCode
      phoneNumber
      website
      tips
      promotionBannerText
      promotionDetails
      promotionColor
      isActive
      areas
      categories {
        id
        name
      }
    }
  }
`;

export const GET_WHERE_TO_GO_CATEGORIES = gql`
  query GetWhereToGoCategories {
    whereToGoCategories {
      id
      name
      description
      isActive
    }
  }
`;

export const GET_WHERE_TO_GO_CATEGORY = gql`
  query GetWhereToGoCategory($id: ID!) {
    whereToGoCategory(id: $id) {
      id
      name
      description
      isActive
    }
  }
`;

// Mutations
export const CREATE_WHERE_TO_GO_ITEM = gql`
  mutation CreateWhereToGoItem($input: CreateWhereToGoInput!) {
    createWhereToGoItem(createWhereToGoInput: $input) {
      id
      title
      description
      imageUrl
      address
      city
      state
      zipCode
      phoneNumber
      website
      tips
      promotionBannerText
      promotionDetails
      promotionColor
      isActive
      areas
      categories {
        id
        name
      }
    }
  }
`;

export const UPDATE_WHERE_TO_GO_ITEM = gql`
  mutation UpdateWhereToGoItem($input: UpdateWhereToGoInput!) {
    updateWhereToGoItem(updateWhereToGoInput: $input) {
      id
      title
      description
      imageUrl
      address
      city
      state
      zipCode
      phoneNumber
      website
      tips
      promotionBannerText
      promotionDetails
      promotionColor
      isActive
      areas
      categories {
        id
        name
      }
    }
  }
`;

export const DELETE_WHERE_TO_GO_ITEM = gql`
  mutation DeleteWhereToGoItem($id: ID!) {
    removeWhereToGoItem(id: $id)
  }
`;

export const CREATE_WHERE_TO_GO_CATEGORY = gql`
  mutation CreateWhereToGoCategory($input: CreateWhereToGoCategoryInput!) {
    createWhereToGoCategory(createCategoryInput: $input) {
      id
      name
      description
      isActive
    }
  }
`;

export const UPDATE_WHERE_TO_GO_CATEGORY = gql`
  mutation UpdateWhereToGoCategory($input: UpdateWhereToGoCategoryInput!) {
    updateWhereToGoCategory(updateCategoryInput: $input) {
      id
      name
      description
      isActive
    }
  }
`;

export const DELETE_WHERE_TO_GO_CATEGORY = gql`
  mutation DeleteWhereToGoCategory($id: ID!) {
    removeWhereToGoCategory(id: $id)
  }
`;

// Get upload URL for image uploading
export const GET_UPLOAD_URL = gql`
  mutation GetUploadUrl($input: FileUploadInput!) {
    getFileUploadUrl(input: $input) {
      uploadUrl
      fileUrl
    }
  }
`; 